module.exports = __webpack_public_path__ + "media/images/social-7e9d28dfc7c2900fa24169a9e2f0f909.jpg";